/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-icon{display:inline-block}app-icon.app-icon-disabled{cursor:not-allowed;pointer-events:none}app-icon.app-icon-disabled svg{opacity:.1}.app-icon svg{stroke-width:0;stroke:currentColor;fill:currentColor}.app-icon.app-baseline svg{position:relative;top:.125em}.app-icon-size-medium>.app-icon.app-baseline>svg{top:.25em}.app-icon-size-large svg{width:6em;height:6em}.app-icon-size-medium svg{width:4em;height:4em}.app-icon-size-normal svg{width:2.9em;height:2.3em}.app-icon-size-small svg{width:1em;height:1em}"];
export { styles as styles };
